import React, { Component } from 'react';
import ActionEditorContainer from '../ActionEditorContainer';
import ActionMicrosoftTeamsEditorComponent from './ActionMicrosoftTeamsEditorComponent';

class ActionTeamsEditorContainer extends Component {
  public render() {
    return <ActionEditorContainer editor={<ActionMicrosoftTeamsEditorComponent />} type='microsoft-teams' icon='microsoft-teams' />;
  }
}

export default ActionTeamsEditorContainer;
